import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

import { selectUserRole } from '@/reducers/userDataReducer'

interface RoleGuardProps {
  allowedRoles: string[]
  redirectTo: string
}

// Note: unlike withRoleProtection (redirects from an effect after the page already mounted),
// this renders nothing for a disallowed role, so no data request or flash of the page happens
export const RoleGuard = ({ allowedRoles, redirectTo }: RoleGuardProps) => {
  const role = useSelector(selectUserRole)

  if (!role || !allowedRoles.includes(role)) return <Navigate replace to={redirectTo} />

  return <Outlet />
}
